export default {
  availableSubscriptionsList: []
}
